import React, { Component, useState, useEffect, useMemo } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// import { withStyles } from '@mui/material/styles';
// import DollarIcon from '@mui/icons-material/AttachMoney';
// import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
// import { translate } from 'react-admin';
import { Title, GET_LIST } from 'react-admin';
import { Link } from "react-router-dom";
import { GetCurrentUserRoles } from '../common/common';
import icon_retailer from './../images/icon-retailer.svg';
import icon_order from './../images/icon-order.svg';
import { getLocalStorageKey } from '../common/common';
import dataProvider from '../myRestProvider';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common';

import { requestForToken,onMessageListener,messaging } from '../firebase';
import { getNotificationPermission } from '../Notification';
import Modal from 'react-responsive-modal';
import Swal from "sweetalert2";
import { onMessage } from "firebase/messaging";
import { useNavigate } from 'react-router-dom';
import {Howl} from 'howler';


const Dashboard = () => {

    const [stats_data, setStats_data] = React.useState(null);
    const localStorageAppType = getLocalStorageKey("app_type");
    const [baseThemeColor, setBaseThemeColor] = useState("clickittheme");
  
    useEffect(() => {
      if (localStorageAppType === "HOLCIM") {
        setBaseThemeColor("holcimtheme");
      } else {
        setBaseThemeColor("clickittheme");
      }
    }, [localStorageAppType]);

    /*------------------------*/
    const navigate = useNavigate();
    const id = getLocalStorageKey("id");
    const [isPermissionModalOpen,setIsPermissionModalOpen] = React.useState(true);
    const [isUserInteracted, setIsUserInteracted] = React.useState(false);
    const audio = new Audio('/public/notification.mp3');

    const [notification, setNotification] = React.useState({title: '', body: ''});
    const notify = () => (
            Swal.fire({
                html: `Title: ${notification.title}  Body: ${notification.body}`,
                icon: "success",
              })
    );

    const redirectToSap = (data) => {
      window.open(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`, "_blank");
      navigate(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`);
    };

    React.useEffect(()=>{
          // const handleUserInteraction = () => {
          //   setIsUserInteracted(true);
          //   document.removeEventListener('click', handleUserInteraction);
          //   document.removeEventListener('keydown', handleUserInteraction);
          // };
      
          // document.addEventListener('click', handleUserInteraction);
          // document.addEventListener('keydown', handleUserInteraction);
      
          // const handleForegroundMessage = () => {
          //   console.log('Message received. ');
          //   if (isUserInteracted) {
          //     audio.play().catch((err) => console.log('Failed to play sound:', err));
          //   }
          // };
      
        onMessage(messaging, (payload) => {
            console.log("foreground payload", payload);
            // handleForegroundMessage();
            var sound = new Howl({
                src: ['/notification.mp3']
              });
              
            sound.play();
            setNotification({title: payload?.notification?.title, body: payload?.notification?.body});
            const notificationTitle = payload.notification.title;
            const notificationBody = payload.notification.body;
            const notificationOptions = {
              body: payload.notification.body,
              sound: 'default',
              icon : 'https://homepages.cae.wisc.edu/~ece533/images/zelda.png'
              
            };
            const notification = new Notification(notificationTitle, {
              body: notificationBody,
              icon: './images/navender_logo.png', // Path to the icon image
              data: { url: 'https://developer.mozilla.org/' } // Custom data, if needed
            });
            
            notification.onclick = (event) => {
              const redirectUrl = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ? `http://localhost:3000/sap_digital_app_orders/${payload?.data?.sap_digital_order_id}/show/3`:`${process.env.API_URL}/sap_digital_app_orders/${payload?.data?.sap_digital_order_id}/show/3`;
              // event.preventDefault(); // prevent the browser from focusing the Notification's tab
              window.open(redirectUrl,"_blank");
            };

            // notification.addEventListener("click", (data) => {
            //   console.log("User opened the notification");
            //   window.open(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`, "_blank");
            //   notification.close(); // close notification when user clicks on it
            // });
            // notification.onclick = (event,data) => {
            //   event.preventDefault();
            //   console.log('clicked on notification');
            //     // redirectToSap(payload.data);
            //     window.open(`/sap_digital_app_orders/${data.sap_digital_order_id}/show/3`, "_blank");
            //     notification.close();
            //     window.parent.focus();
            // };
            // return () => {
            //   document.removeEventListener('click', handleUserInteraction);
            //   document.removeEventListener('keydown', handleUserInteraction);
            // };
        });
    },[]);

    // React.useEffect(() => {
    //   if (navigator.serviceWorker) {
    //     navigator.serviceWorker.addEventListener('message', (event) => {
    //       if (event.data === 'playSound' && isUserInteracted) {
    //         audio.play().catch((err) => console.log('Failed to play sound::::::::', err));
    //       }
    //     });
    //   }
    // }, [isUserInteracted]);

    React.useEffect(()=>{
        if(Notification.permission === 'granted'){
            getNotificationPermission(id).then(() =>{
              console.log('hi i a here in this app js')
              setIsPermissionModalOpen(false);
            })
        }
    },[])

    React.useEffect(()=>{
        if (notification?.title ){
            notify()
            }     
    },[notification])


    async function notificationPermission(){
        console.log('hi i a here in this app js')
        await getNotificationPermission(id).then(() =>{
          setIsPermissionModalOpen(false);
        })
      }
    
    function displayPermissionModal(){
        console.log('wasssssssssssssssssupppppppp');
        return(
            <Modal open={isPermissionModalOpen} onClose={()=>setIsPermissionModalOpen(!isPermissionModalOpen)} center>
            <h3>{'modalMsg'}</h3>
                <button onClick={notificationPermission}>click me</button>
            </Modal>
        )
    }

  /*------------------------*/

    React.useLayoutEffect(() => {
        getStatsData()
    }, [])

    const getStatsData = () => {
        // const options = CommonHeaderOption();
        // const apiUrl = RUN_TIME_API_ENDPOINT;
        // fetch(`${apiUrl}/dashboard_stats`, options)
        dataProvider(GET_LIST, 'dashboard_stats', {})
            .then(json => {
                setStats_data(json.data)
            })
            .catch(error => console.log('error', error));
    }

    const dashboardRenderRole = () => {
        let roleData = GetCurrentUserRoles();
        const showAllOrders = getLocalStorageKey('show_all_orders');
        if (roleData === false) {
            return (<div> </div>);
        }

        return (
            <div>
                <div className="dashboard-container">
                    <div className="dashboard-inner">

                        <div className="dashboard-box-container">

                            <div className="dashboard-box"> <Link to={`/businesses`}><img alt="Retailer Icon" src={icon_retailer} className="icon-image-dashboard" /></Link><p className="dashboard-label">Retailers</p><p className="dashboard-value"><Link to={`/businesses`}>{stats_data.retailers_total}</Link></p></div>
                            <div className="dashboard-box"><Link to={`/${showAllOrders ? "sap_digital_orders" : "sap_digital_app_orders"}`}><img alt="Order Icon" src={icon_order} className="icon-image-dashboard" /></Link><p className="dashboard-label">Digital Order By Retailers</p><p className="dashboard-value"><Link to={`/${showAllOrders ? "sap_digital_orders" : "sap_digital_app_orders"}`}>{stats_data.digital_orders_total}</Link></p></div>
                        </div>
                    </div>
                </div>

                {/* <div>{connectionStatus}</div> */}

                {/* <button onClick={
                    (e)=>{
                        e.preventDefault();
                        handleClickSendMessage();

                    }
                    }>msg
                </button>

                <button onClick={
                    (e)=>{
                        e.preventDefault();
                        joinRoom();
                    }
                    }>join room
                </button> */}

            </div>
        );
    }

        return (
            <React.Fragment>
            {
            (isPermissionModalOpen && !(Notification.permission === 'granted')) &&
                <Modal
                open={isPermissionModalOpen}
                onClose={() => setIsPermissionModalOpen(false)}
                center
                >
                    <div className="an-txt">
                    Please click on Allow when the browser asks you to provide
                    access to notifications so that you can receive chat
                    notifications.
                    </div>
                    <button className="an-btn" onClick={notificationPermission}>
                    OK
                    </button>
                </Modal>
            }
                <Card className="welcom_container">
                    <center>
                        {/* <Title title="Welcome to Navendor" /> */}
                    <Title title={baseThemeColor === 'clickittheme'? "Welcome to Clickit admin dashboard" : "Welcome to HOLCIM+ admin dashboard"} /></center>
                    <CardContent>
                        {
                            stats_data ?
                                dashboardRenderRole()
                                : <div className="custom-loader"><CircularProgress /></div>
                        }
                    </CardContent>
                </Card>
            </React.Fragment>
        );
}

export default Dashboard;
